module.exports = __webpack_public_path__ + "img/research_iton_4.3096a9d8.png";